import React, {useCallback, useEffect, useMemo, useState} from "react";
import Box from "@mui/material/Box";
import {
    MaterialReactTable, MRT_BottomToolbar,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from "material-react-table";
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import {Typography} from "@mui/material";

const DETAIL_PANEL_GRID_SX = {
    display: 'grid',
    margin: 'auto',
    gridTemplateColumns: 'minmax(72px, 0.7fr) minmax(56px, 0.6fr) minmax(160px, 1fr) minmax(40px, 0.45fr) repeat(8, minmax(44px, 0.65fr))',
    columnGap: '12px',
    alignItems: 'center',
    padding: '10px',
};

const DETAIL_PANEL_CELL_SX = {
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};


const CurrentMapDetails = ({
                               data,
                               setData,
                               tableOptions,
                               tableOptionsHandle,
                           }) => {
        const [expanded, setExpanded] = useState({})

        useEffect(() => {
            setExpanded({});
        }, [data]);

        const columns = useMemo(() => {
            const baseColumns = [
                {
                    id: 'sequentialNumber',
                    header: 'Порядковый номер',
                    accessorKey: 'sequentialNumber',
                    size: 400,
                    grow: true,
                },
                {
                    id: 'name',
                    header: 'Наименование',
                    accessorKey: 'name',
                    size: 600,
                    grow: true,
                    Cell: ({cell, row}) => <Box sx={{
                        color: (theme) => row.original.modified ? theme.palette.success.main : (row.original.excluded ? theme.palette.error.main : (row.original.ignored ? theme.palette.pencil.main : 'black'))
                    }}>{cell.getValue()}</Box>
                },
                {
                    id: 'length',
                    header: 'W',
                    accessorKey: 'length',
                    size: 400,
                    grow: true,
                    Cell: ({cell, row}) => <Box sx={{
                        color: (theme) => row.original.modified ? theme.palette.success.main : (row.original.excluded ? theme.palette.error.main : (row.original.ignored ? theme.palette.pencil.main : 'black'))
                    }}>{cell.getValue()}</Box>
                },
                {
                    id: 'width',
                    header: 'H',
                    accessorKey: 'width',
                    size: 400,
                    grow: true,
                    Cell: ({cell, row}) => <Box sx={{
                        color: (theme) => row.original.modified ? theme.palette.success.main : (row.original.excluded ? theme.palette.error.main : (row.original.ignored ? theme.palette.pencil.main : 'black'))
                    }}>{cell.getValue()}</Box>
                }]

            return baseColumns;

        }, [data, setData]);

        return (
            <Box sx={{
                display: 'flex', flexDirection: "column", gap: "30px", overflow: 'auto',
                maxWidth: 2000
            }}>
                <MaterialReactTable
                    muiTableBodyCellProps={({cell, table}) => {
                        return ({
                            sx: () => ({
                                borderRight: '1px solid #EAEBEA',
                                "&:first-of-type": {
                                    padding: 0,
                                    width: "50px",
                                    height: "36px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    color: (theme) => theme.palette.text.light,
                                    "& .MuiButtonBase-root": {
                                        borderRadius: "4px",
                                        width: "24px",
                                        height: "24px",
                                        opacity: 1,
                                        margin: 0,
                                        padding: 0,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.stroke,
                                        }
                                    }
                                },
                            })
                        })
                    }}
                    muiTableHeadCellProps={{
                        sx: {
                            border: '1px solid #EAEBEA',
                            backgroundColor: "#F5F6FA",
                            padding: "10px",
                            paddingBottom: " 0.2rem",
                            paddingTop: "0.2rem"
                        },
                    }}
                    muiTableBodyRowProps={({row}) => {
                        return ({
                            sx: () => ({
                                height: row.getIsExpanded() ? '36px' : '0px',
                                cursor: "pointer",
                                "&:hover& td:after": {
                                    display: "none",
                                },
                                '&:nth-of-type(4n+3)': {
                                    backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                    "&.MuiTableRow-root.Mui-selected": {
                                        backgroundColor: (theme) => theme.palette.primary.light,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.light50,
                                        },
                                    },
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.stroke,
                                    },
                                },
                                backgroundColor: "white",
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                },
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light70,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                            })
                        })
                    }}
                    muiSearchTextFieldProps={{
                        placeholder: `Поиск`,
                        sx: {
                            paddingTop: "5px",
                            paddingBottom: "0px",
                            "& .MuiCollapse-root": {
                                borderRadius: '12px',
                                height: 40, width: 290,
                                "& .MuiSvgIcon-root": {
                                    color: "#737478"
                                },
                                '& .MuiOutlinedInput-input': {
                                    padding: 0
                                }
                            }
                        },
                        variant: 'outlined',
                    }}
                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            header: "",
                            size: 3,
                            minSize: 3,
                            grow: false,
                        },
                        'mrt-row-select': {
                            size: "50px",
                            grow: false,
                        },
                        "mrt-row-expand": {
                            size: "50px",
                            grow: false,

                        }
                    }}
                    columns={columns}
                    data={data}
                    rowHeight={13}
                    columnSpacing={1}
                    initialState={{
                        columnVisibility: {
                            id: false,
                        },
                        density: "compact",
                        expanded: expanded,
                        sorting: [{id: 'sequentialNumber', desc: false}],
                    }}
                    onPaginationChange={(updater) => {
                        tableOptionsHandle(updater(tableOptions));
                    }}
                    onExpandedChange={setExpanded}
                    state={{expanded, showGlobalFilter: true, pagination: tableOptions,}}
                    getRowId={(originalRow) => String(originalRow.sequentialNumber ?? originalRow.id ?? originalRow.name)}
                    selectionPadding={1}
                    selectionCss={{
                        backgroundColor: 'lightblue',
                        borderWidth: '2px',
                        borderStyle: 'solid',
                        borderColor: 'blue',
                        borderRadius: '4px',
                    }}
                    localization={MRT_Localization_RU}
                    selectAllMode={"all"}
                    muiTableContainerProps={{
                        sx: {
                            maxWidth: 2000,
                            maxHeight: `calc(100vh - 500px)`,
                        }
                    }}
                    muiToolbarAlertBannerProps={{
                        sx: {
                            backgroundColor: (theme) => theme.palette.primary.light,
                            "& .MuiStack-root": {
                                padding: 0,
                            },
                        }
                    }}

                    renderDetailPanel={({row}) => {
                        return <Box sx={{border: "1px solid black", overflowX: 'auto'}}>
                            <Box
                                sx={{
                                    ...DETAIL_PANEL_GRID_SX,
                                    borderBottom: "1px solid black",
                                    marginBottom: "10px"
                                }}
                            >
                                <Typography sx={DETAIL_PANEL_CELL_SX}>Количество</Typography>
                                <Typography sx={DETAIL_PANEL_CELL_SX}>Позиция</Typography>
                                <Typography sx={DETAIL_PANEL_CELL_SX}>Наименование</Typography>
                                <Typography sx={DETAIL_PANEL_CELL_SX}>кол.</Typography>
                                <Typography sx={DETAIL_PANEL_CELL_SX}>W</Typography>
                                <Typography sx={DETAIL_PANEL_CELL_SX}>H</Typography>
                                <Typography sx={DETAIL_PANEL_CELL_SX}>Тол.</Typography>
                                <Typography sx={DETAIL_PANEL_CELL_SX}>l1</Typography>
                                <Typography sx={DETAIL_PANEL_CELL_SX}>l2</Typography>
                                <Typography sx={DETAIL_PANEL_CELL_SX}>w1</Typography>
                                <Typography sx={DETAIL_PANEL_CELL_SX}>w2</Typography>
                                <Typography sx={DETAIL_PANEL_CELL_SX}>Паз</Typography>
                            </Box>
                            {row.original.details?.map((el, index) => {
                                return <Box
                                    key={index}
                                    sx={DETAIL_PANEL_GRID_SX}
                                >
                                    <Typography sx={DETAIL_PANEL_CELL_SX}>{el.second.quantity}</Typography>
                                    <Typography sx={DETAIL_PANEL_CELL_SX}>{el.second.position}</Typography>
                                    <Typography sx={DETAIL_PANEL_CELL_SX}>{el.second.name}</Typography>
                                    <Typography sx={DETAIL_PANEL_CELL_SX}>{el.first}</Typography>
                                    <Typography sx={DETAIL_PANEL_CELL_SX}>{el.second.length}</Typography>
                                    <Typography sx={DETAIL_PANEL_CELL_SX}>{el.second.width}</Typography>
                                    <Typography sx={DETAIL_PANEL_CELL_SX}>{el.second.height}</Typography>
                                    <Typography sx={DETAIL_PANEL_CELL_SX}>{el.second.l1}</Typography>
                                    <Typography sx={DETAIL_PANEL_CELL_SX}>{el.second.l2}</Typography>
                                    <Typography sx={DETAIL_PANEL_CELL_SX}>{el.second.w1}</Typography>
                                    <Typography sx={DETAIL_PANEL_CELL_SX}>{el.second.w2}</Typography>
                                    <Typography sx={DETAIL_PANEL_CELL_SX}>{el.second.groove}</Typography>
                                </Box>
                            })}
                        </Box>
                    }}
                    renderTopToolbar={({table}) => {
                        return <Box sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "7px",
                            backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                        }}>
                            <MRT_ToolbarAlertBanner table={table}/>
                            <Box sx={{display: "flex"}}>
                                <MRT_ToggleFiltersButton table={table}/>
                                <MRT_GlobalFilterTextField table={table}/>
                            </Box>
                        </Box>
                    }}
                    renderBottomToolbar={({table}) => {
                        const tableProps = table.getState().grouping.length > 0
                            ? {
                                ...table,
                                options: {
                                    ...table.options,
                                    localization: {
                                        ...table.options.localization,
                                        rowsPerPage: `Всего строк: ${tableOptions.totalElements}. Сгруппированных элементов на странице:`
                                    }
                                }
                            }
                            : table
                        return <MRT_BottomToolbar table={tableProps}/>
                    }}
                />
            </Box>
        );
    }
;
export default CurrentMapDetails